import { render, staticRenderFns } from "./userAddress.vue?vue&type=template&id=1b8e8546&scoped=true&"
import script from "./userAddress.vue?vue&type=script&lang=js&"
export * from "./userAddress.vue?vue&type=script&lang=js&"
import style0 from "./userAddress.vue?vue&type=style&index=0&id=1b8e8546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e8546",
  null
  
)

export default component.exports